/** @jsx jsx */

import { css, jsx } from '@emotion/react';
import { useGlobalTheme } from '@atlaskit/theme/components';
import { h600 } from '@atlaskit/theme/typography';
var formSectionDescriptionStyles = css({
  marginTop: "var(--ds-space-100, 8px)"
});
var formSectionTitleStyles = css({
  marginTop: 0,
  marginRight: "var(--ds-space-400, 32px)",
  lineHeight: "var(--ds-space-400, 32px)",
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  // Use "clip" overflow to allow ellipses on x-axis without clipping descenders
  '@supports not (overflow-x: clip)': {
    overflow: 'hidden'
  },
  '@supports (overflow-x: clip)': {
    overflowX: 'clip'
  }
});
var formSectionWrapperStyles = css({
  marginTop: "var(--ds-space-300, 24px)"
});

// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var lightH600Styles = css(h600({
  theme: {
    mode: 'light'
  }
}));
// eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
var darkH600Styles = css(h600({
  theme: {
    mode: 'dark'
  }
}));
var FormSectionWrapper = function FormSectionWrapper(_ref) {
  var children = _ref.children;
  return jsx("div", {
    css: formSectionWrapperStyles
  }, children);
};
var FormSectionTitle = function FormSectionTitle(_ref2) {
  var children = _ref2.children;
  var _useGlobalTheme = useGlobalTheme(),
    mode = _useGlobalTheme.mode;
  return jsx("h3", {
    css: [formSectionTitleStyles, mode === 'light' ? lightH600Styles : darkH600Styles]
  }, children);
};
var FormSectionDescription = function FormSectionDescription(_ref3) {
  var children = _ref3.children;
  return jsx("div", {
    css: formSectionDescriptionStyles
  }, children);
};

/**
 * __Form section__
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 */
var FormSection = function FormSection(_ref4) {
  var children = _ref4.children,
    description = _ref4.description,
    title = _ref4.title;
  return jsx(FormSectionWrapper, null, title && jsx(FormSectionTitle, null, title), description && jsx(FormSectionDescription, null, description), children);
};
export default FormSection;